const UNITS = ['B', 'KB', 'MB', 'GB'] as const;

/** 48213 → "47.1 KB". Binary steps, one decimal above bytes, no trailing ".0". */
export function formatBytes(bytes: number): string {
  let value = Math.max(0, bytes);
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  const rounded = unit === 0 ? String(Math.round(value)) : value.toFixed(1).replace(/\.0$/, '');
  return `${rounded} ${UNITS[unit]}`;
}
